module.exports = __webpack_public_path__ + "static/media/InnerBox_Up.4b72b284.svg";